"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const custom_1 = require("./custom");
exports.theme = custom_1.createThemeFromColor('#F5F5F5', 'light-gray', 'Xám nhạt', {
    tintColor: '#29333D',
    override: {
        primaryBackgroundColor: '#000000',
    },
});
//# sourceMappingURL=light-gray.js.map